// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.popup-menu {
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    color: var(--text-color);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
}

div.popup-menu:focus {
    outline: none;
}

div.popup-menu-item-disabled {
    color: var(--text-color-disabled);
}

div.popup-menu > *:focus {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/PopupMenu.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,wBAAwB;IACxB,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;IACxC,aAAa;AACjB","sourcesContent":["div.popup-menu {\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    color: var(--text-color);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n}\n\ndiv.popup-menu:focus {\n    outline: none;\n}\n\ndiv.popup-menu-item-disabled {\n    color: var(--text-color-disabled);\n}\n\ndiv.popup-menu > *:focus {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
